import Dispatcher from "../Dispatcher";
import { Store } from "flux/utils";

import { Address } from "../models/Address";
import { Customer } from "../models/Customer";
import { GeoLocation } from "../models/GeoLocation";
import { Name } from "../models/Name";

import ShoppingBasketStore from "./ShoppingBasketStore";

import { DarienSqlAction } from "../actions/DarienSqlActions";
import { ShoppingBasketAction } from "../actions/ShoppingBasketActions";
import $ = require("jquery");
import { ResidentVerification, CommercialVerification } from "../components/darien/Models";


let baseUrl = (window as any)["baseUrl"];

let verificationResults: ResidentVerification = {
	HasHauler: false,
	ResidentId: 0,
	PlatesVerified: [],
	IsSenior: false
};
let commercialVerificationResults: CommercialVerification = {
	AccountNumber:"",
	Permits: []
}
class DarienSqlStore extends Store<DarienSqlAction<any>>
{
	constructor(dispatcher: any)
	{
		ShoppingBasketStore.loadBasketFromServer();
		super(dispatcher);
	}
	cleanUpPlateNumber(licensePlateNumber: string)
	{
		return licensePlateNumber.replace(/-| /g, "").toUpperCase();
	}
	verifyResidency(lastName: string, licensePlateNumber: Array<string>)
	{
		var data = {
			LastName: lastName,
			PlateNumbers: <string[]>[]
		};
		for (var i = 0; i < licensePlateNumber.length; i++)
		{
			var newPlate = this.cleanUpPlateNumber(licensePlateNumber[i]);
			if (data.PlateNumbers.indexOf(newPlate) == -1) {
				data.PlateNumbers[i] = this.cleanUpPlateNumber(licensePlateNumber[i]);
			}
		}

		var service = {
			url: baseUrl + "/api/v1/resident/verify",
			type: "POST",
			contentType: "application/json",
			dataType: "json",
			data: JSON.stringify(data)
		};

		$.ajax(service).done((data) =>
		{
			this.getDispatcher().dispatch(new DarienSqlAction("VERIFICATION_PROCESSED", { result: data }));
		});

		return 0;
	}
	verifyCommercialAccount(accountNumber: string, permitNumbers: Array<string>)
	{
		var data = {
			AccountNumber: accountNumber,
			Permits: permitNumbers
		}
		var service = {
			url: baseUrl + "/api/v1/resident/verifycommercial",
			type: "POST",
			contentType: "application/json",
			dataType: "json",
			data: JSON.stringify(data)
		};

		return $.ajax(service).done((data) =>
		{
			this.getDispatcher().dispatch(new DarienSqlAction("VERIFICATION_PROCESSED_COMMERCIAL", { result: data }));
		});
	}
	addCommercialPermits()
	{
		ShoppingBasketStore.addNote("Account Number: "+ commercialVerificationResults.AccountNumber);
		for (var i = 0; i < commercialVerificationResults.Permits.length; i++)
		{
			ShoppingBasketStore.addNote("Permit: " + [ commercialVerificationResults.Permits[i]]);
		}
		return ShoppingBasketStore.setLineItemQuantity("25", commercialVerificationResults.Permits.length);
	}
	addPermits()
	{
		var data = {
			ResidentId: verificationResults.ResidentId,
			Permits: <any[]>[],
			PaymentMethod: "Visa"
		};
		var basket = ShoppingBasketStore.getBasket();
		for (var i = 0; i < basket.lineItems.length; i++)
		{
			data.Permits[i] = {
				PlateNumber: verificationResults.PlatesVerified[i].PlateNumber,
				Amount: basket.lineItems[i].originalPrice
			};
		}

		var service = {
			url: baseUrl + "/api/v1/resident/permit",
			type: "POST",
			contentType: "application/json",
			dataType: "json",
			data: JSON.stringify(data)
		};

		return $.ajax(service);
	}
	private emptyResident(): Customer
	{
		return {
			id: "",
			emailAddress: "",
			firstName: "",
			middleName: "",
			lastName: "",
			companyName: "",
			addresses: [],
			phoneNumbers: [],
			metadata: {}
		}
	}

	populateShoppingBasket(resident: ResidentVerification)
	{
		if (resident !== null)
		{
			var basket = ShoppingBasketStore.getBasket();
			var targetAddress = this.composeAddress(resident.Resident);

			// if the basket is null at this point, take defensive steps...

			// fill out customer information
			ShoppingBasketStore.addAddressToCustomer(targetAddress).then(() =>
			{
				return ShoppingBasketStore.assignPerferredAddress(targetAddress, "ship");
			}).then(() =>
			{
				return ShoppingBasketStore.assignPerferredAddress(targetAddress, "bill");
			}).then(() =>
			{
				var chain: JQueryPromise<any>;
				if (resident.IsSenior == false) {
					if (resident.HasHauler) {
						chain = ShoppingBasketStore.setLineItemQuantity("22", 1);//regular
					} else {
						chain = ShoppingBasketStore.setLineItemQuantity("26", 1);//no dump service
					}
				} else {
					chain = ShoppingBasketStore.setLineItemQuantity("24", 1); // Senior free permit first
				}
				chain.done(() =>
				{
					if (resident.PlatesVerified.length >= 2)
					{
						if (resident.IsSenior == false) {
							ShoppingBasketStore.setLineItemQuantity("24", 1).done(() => {
								if (resident.PlatesVerified.length === 3) {
									ShoppingBasketStore.setLineItemQuantity("23", 1); // Extra permit
								}
							});//free permit
						} else {
							if (resident.HasHauler) {
								chain = ShoppingBasketStore.setLineItemQuantity("22", 1).done(() => {
									if (resident.PlatesVerified.length === 3) {
										ShoppingBasketStore.setLineItemQuantity("23", 1); // Extra permit
									}
								});//regular
							} else {
								chain = ShoppingBasketStore.setLineItemQuantity("26", 1).done(() => {
									if (resident.PlatesVerified.length === 3) {
										ShoppingBasketStore.setLineItemQuantity("23", 1); // Extra permit
									}
								});//no dump service
							}
						}
					}
				});
			});
		}
	}

	private composeAddress(resident: Customer): Address
	{
		if (resident.addresses !== undefined && resident.addresses !== null)
		{
			return resident.addresses[0];
		}

		return new Address();
	}

	__onDispatch(action: any)
	{
		switch (action.type)
		{
			case "VERIFICATION_PROCESSED":
				verificationResults = action.value.result;
				this.__emitChange();
				break;
			case "VERIFICATION_PROCESSED_COMMERCIAL":
				commercialVerificationResults = action.value.result;
				this.__emitChange();
				break;


		}
	}

	fetchResident(): ResidentVerification { return verificationResults; }
	fetchCommercial() { return commercialVerificationResults; }
}

export default new DarienSqlStore(Dispatcher);


// WEBPACK FOOTER //
// ./src/stores/DarienSqlStore.ts